import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LayoutDashboard, FileText, Truck, MessagesSquare, Route, LogOut, ExternalLink } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/cotizaciones", label: "Cotizaciones", icon: FileText },
  { to: "/admin/flota", label: "Flota", icon: Truck },
  { to: "/admin/testimonios", label: "Testimonios", icon: MessagesSquare },
  { to: "/admin/rutas", label: "Rutas", icon: Route },
];

export default function AdminLayout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => { logout(); navigate("/admin/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-[#0A0908] text-[#F5EFE0] grain flex" data-testid="admin-layout">
      <aside className="hidden md:flex flex-col w-64 border-r border-[#3A3229] p-5 shrink-0">
        <a href="/" className="flex items-center gap-3 pb-5 border-b border-[#3A3229]">
          <img src="/logo-lineas-doradas.webp" alt="Líneas Doradas" className="h-11 w-11 object-contain shrink-0" />
          <div>
            <div className="font-display text-[15px] text-[#F5EFE0]">Líneas Doradas</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#D4AF37]/80">Admin</div>
          </div>
        </a>

        <nav className="mt-6 flex flex-col gap-1">
          {nav.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink key={n.to} to={n.to} end={n.end}
                       data-testid={`nav-${n.label.toLowerCase()}`}
                       className={({ isActive }) =>
                         `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm ${
                           isActive ? "bg-[#D4AF37]/15 text-[#F5EFE0] border border-[#D4AF37]/40" : "text-[#F5EFE0]/70 hover:bg-[#D4AF37]/8 border border-transparent"
                         }`}>
                <Icon size={16} className="text-[#E8C87A]" /> {n.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="mt-auto pt-6 border-t border-[#3A3229]">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-xs text-[#F5EFE0]/60 hover:text-[#E8C87A] mb-3">
            <ExternalLink size={13} /> Ver sitio público
          </a>
          <div className="text-xs text-[#F5EFE0]/50 truncate">{admin?.email}</div>
          <button data-testid="logout-btn" onClick={doLogout} className="mt-3 w-full btn-ghost-gold px-3 py-2 rounded-full text-xs flex items-center justify-center gap-2">
            <LogOut size={13} /> Cerrar sesión
          </button>
        </div>
      </aside>

      <div className="flex-1 min-w-0">
        {/* Mobile top bar */}
        <div className="md:hidden flex items-center justify-between px-4 h-14 border-b border-[#3A3229] sticky top-0 bg-[#0A0908]/95 z-40">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-full border border-[#D4AF37] flex items-center justify-center font-display text-[#E8C87A] text-sm">LD</span>
            <span className="font-display text-sm">Admin</span>
          </div>
          <button onClick={doLogout} data-testid="logout-btn-mobile" className="text-xs text-[#E8C87A]">Salir</button>
        </div>

        {/* Mobile nav pills */}
        <div className="md:hidden flex gap-2 overflow-x-auto px-4 py-3 border-b border-[#3A3229]">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
                     className={({ isActive }) => `text-xs px-3 py-1.5 rounded-full whitespace-nowrap ${isActive ? "bg-[#D4AF37] text-[#0A0908]" : "border border-[#3A3229] text-[#F5EFE0]/70"}`}>
              {n.label}
            </NavLink>
          ))}
        </div>

        <main className="p-5 md:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
